import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import Quiz from "./pages/Quiz";
import Summary from "./pages/Summary";
import Success from "./pages/Success";
import Admin from "./pages/Admin";

function App() {
    return (
        <div className="App font-body">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/quiz" element={<Quiz />} />
                    <Route path="/summary/:submissionId" element={<Summary />} />
                    <Route path="/success" element={<Success />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
        </div>
    );
}

export default App;
